import { useMemo } from 'react'
import { patientName } from 'Data/format.js'
import toPascalCase from 'to-pascal-case'

function mergeAndDeduplicate({ direct_matches, indirect_matches }) {
  let seen = new Set()
  let data = []

  for (let person of [...direct_matches, ...indirect_matches]) {
    if (!seen.has(person._id)) {
      seen.add(person._id)
      data.push(person)
    }
  }

  return data
}

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return []

    let persons = mergeAndDeduplicate(data)

    return persons
      .filter(person => {
        let [from_person_relationship] = person.from_person_relationships
        return (
          person.public_user === null ||
          person.public_user.account === null ||
          (from_person_relationship &&
            from_person_relationship.permitted_to_see_info === false)
        )
      })
      .map(person => {
        let text = patientName(person)
        let [from_person_relationship] = person.from_person_relationships
        if (from_person_relationship) {
          text = `${text} (${toPascalCase(
            from_person_relationship.type
          )} - ${toPascalCase(from_person_relationship.role)})`
        } else {
          text = `${text} (Patient)`
        }

        return {
          id: person._id,
          text,
          email: person.public_user?.account?.email || null,
          already_has_account: person.public_user?.account || false,
          permitted_to_see_info:
            from_person_relationship?.permitted_to_see_info || false,
        }
      })
  }, [data])
}
